import React from "react";

const Washing_17 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 2H30V30H2V2ZM0 0H2H30H32V2V30V32H30H2H0V30V2V0ZM8 17H24V15H8V17Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_17;
